<template lang="pug">
  header
    .container-content-header(v-if="!noHeader")
      .display-block 
        slot(name="left")
      .display-block 
        slot(name="right")
    .container-content
      slot
</template>

<script>
export default {
  props: {
    noHeader: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="less">
@import (reference) "../assets/general";
.container-content-header {
  .flex(center, space-between);
  height: 80px;

  h3 {
    margin: 0;
    font-size: @font-size-big;
    font-weight: normal;

    @media screen and (max-width: 500px) {
      padding: 0 0.5em;
    }
  }

  h6 {
    margin: 0;
    font-size: 15px;
    color: #333;
    margin-top: 2px;
  }

  @media screen and (max-width: 500px) {
    height: 60px;
  }
}

.container-content {
  .max-width;
}
</style>
